import { useEffect, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ContactModal from "../components/ContactModal";
import "../styles/page-solutions.css";

const CTA_LABEL = "Begin a partnership";




/* ──────── nav ──────── */



/* ──────── solutions hero ──────── */

function SolutionsHero() {
  return (
    <section className="page-hero" id="top" data-screen-label="01 Solutions hero">
      <div className="wrap">
        <span className="eyebrow">Our ecosystem</span>
        <h1 className="page-hero-h">Beyond lead generation. <span className="accent ink">An ecosystem that delivers.</span></h1>
        <p className="page-hero-sub">We spent more than 17 years building an ecosystem that does more than fill your pipeline. It gives you options most agencies can't. Cleaner leads. Sharper qualification. Live calls at peak intent. Sales closed for you, end to end. Each one a different way to grow, and yours to pick as you scale.</p>
      </div>
    </section>);

}

/* ──────── solutions list ──────── */

function Solutions() {
  const items = [
  {
    n: "01",
    lead: "Upside ", word: "Lead",
    sub: "Intelligent Lead Management and Distribution",
    body: <>Upside Lead is our proprietary lead management system, built to control, route, and optimize demand in real time. Leads are intelligently distributed based on client criteria, capacity, and performance rules, ensuring consistent flow and structured delivery.<br /><br />This is the core of everything we do, a repeatable acquisition engine <span className="accent">designed to deliver predictable, scalable growth.</span></>
  },
  {
    n: "02",
    lead: "Upside ", word: "Qualify",
    sub: "Advanced Lead Qualification",
    body: <>Upside Qualify adds a customized qualification layer built around your exact criteria. Beyond standard filters, we apply structured validation rules, detailed screening questions, and defined eligibility checks before a lead reaches your pipeline. The result is <span className="accent">tighter alignment, less waste, and prospects that match</span> your commercial requirements.</>
  },
  {
    n: "03",
    lead: "Upside ", word: "Connect",
    sub: "AI-Powered Direct Call Connect",
    body: <>Upside Connect turns intent into conversation. When a prospect is highly engaged, our AI-powered system connects them straight to your sales team in real time. Instead of chasing cold call-backs hours later, your agents speak to prospects while the interest is at its peak, which <span className="accent">lifts contact rates significantly</span> and speeds up conversion.</>
  },
  {
    n: "04",
    lead: "Upside ", word: "Auction",
    sub: "Dynamic Lead Distribution",
    body: <>Upside Auction enables competitive lead distribution through intelligent, real-time bidding. For clients open to shared markets, leads are allocated dynamically based on demand, price, and performance. Every lead finds its place at the price the market sets. This model ensures <span className="accent">efficiency, transparency, and maximum value extraction</span> per enquiry.</>
  },
  {
    n: "05",
    lead: "Upside ", word: "Sales",
    sub: "From Lead to Revenue",
    body: <>Upside Sales goes beyond lead generation. We optimize the entire acquisition environment to drive completed sales, not just enquiries. Ideal for e-commerce and transactional businesses, this model ties our performance directly to your revenue. <span className="accent">You don't pay for leads that might convert. You pay only for sales.</span></>
  }];


  return (
    <section className="sol" id="sol-current" data-screen-label="02 Solutions">
      <div className="wrap">
        <div className="sol-head">
          <div>
            <span className="eyebrow">The ecosystem</span>
          </div>
          <div>
            <h2>Five ways to grow. <span className="accent ink">Purpose-built to scale.</span></h2>
          </div>
        </div>
        <div className="sol-list">
          {items.map((it, i) =>
          <div className="sol-block" key={i}>
              <div className="sol-num"><b>{it.n}</b></div>
              <div className="sol-id">
                <h3 className="sol-name">{it.lead}<span className="accent">{it.word}</span></h3>
                <span className="sol-sub">{it.sub}</span>
              </div>
              <p className="sol-body">{it.body}</p>
            </div>
          )}
        </div>
      </div>
    </section>);

}

/* ──────── solutions closing ──────── */

function SolutionsClosing({ ctaLabel, onCta }) {
  return (
    <section className="closing" data-tone="dark" data-screen-label="03 Closing CTA">
      <div className="wrap">
        <div className="closing-grid">
          <div>
            <span className="eyebrow">Next step</span>
          </div>
          <div>
            <h2>Start the <em>conversation.</em></h2>
            <p className="closing-side" style={{ marginTop: 28 }}>
              Which solutions you need depends on your goals. Let's work out the right ones together.
            </p>
            <div className="closing-foot">
              <button className="link-btn-primary" onClick={onCta}>
                {ctaLabel} <span className="arrow">→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>);

}

/* ──────── footer ──────── */

function SolutionsPage() {
  const [csOpen, setCsOpen] = useState(false);

  useEffect(() => {document.body.setAttribute("data-density", "standard");}, []);

  const openCs = (e) => {if (e) e.preventDefault();setCsOpen(true);};

  return (
    <div className="page page-solutions">
      <Nav onCta={openCs} ctaLabel={CTA_LABEL} />
      <SolutionsHero />
      <Solutions />
      <SolutionsClosing ctaLabel={CTA_LABEL} onCta={openCs} />
      <Footer onContact={openCs} />

      <ContactModal open={csOpen} onClose={() => setCsOpen(false)} />
    </div>);

}

export default SolutionsPage;
